// hooks/useClientUtilization.ts
import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

export const useClientUtilization = (clientId?: number | null) => {
  const client = useMyProviderDataClient();
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!clientId) return;

    const load = async () => {
      setLoading(true);

      const res = await client.get(
        "/EmployeeInformation/ClientUtilization",
        { params: { clientid: clientId } }
      );

      const d = res.data[0];

      setData({
        ID: clientId,
        RequestedHours: `${d["Total Hrs Requested to Date"]?.toFixed(0) ?? 0} hrs`,
        UsedHours: `${d["Total Hours Used to Date"]?.toFixed(0) ?? 0} hrs`,
        Percentage: `${d["Total Hours Used Percentage"]?.toFixed(0) ?? 0}%`,
        Unallocated: `${d["Unallocated Percentage"]?.toFixed(0) ?? 0}%`,
        AvgRequested: `${d["Average Weekly Hours Requested"]?.toFixed(0) ?? 0} hrs`,
        AvgUsed: `${d["Average Weekly Hours Used"]?.toFixed(0) ?? 0} hrs`,
        PossibleHours:
          d["Hours Possible to Fill"] != null
            ? `${d["Hours Possible to Fill"].toFixed(0)} hrs`
            : "No Hours",
      });

      setLoading(false);
    };

    load();
  }, [clientId, client]);

  return { data, loading };
};